import http from './index'
export default {
  // 获取部件列表
  widgetList (params) {
    return http.get('/front/widget/list', params)
  },
  //  获取模板列表
  schemaWidgetList (params) {
    return http.get('/front/layoutSchema/list', params)
  },
  schemaWidgetInfo (params) {
    return http.get('/front/schemaWidget', params)
  },
  applyBigdata (params) {
    return http.post(
      `/front/userWidget/save/bigData?bigDataPageTitle=${params.title}`,
      params.list
    )
  }, // 获取首页配置信息
  userWidget (params) {
    return http.get('/front/userWidget/', params)
  },
  // 保存配置为模板
  save (params) {
    return http.post('/front/schemaWidget/save', params)
  },
  //  配置另存为模板
  saveNew (params) {
    return http.post('/front/schemaWidget/save/bigData', params)
  },
  // 删除模板
  delMould (params) {
    return http.post('/front/layoutSchema/delete', params)
  }
}
